import { render, staticRenderFns } from "./SectionGallery.vue?vue&type=template&id=5988c1ba&scoped=true"
import script from "./SectionGallery.vue?vue&type=script&lang=js"
export * from "./SectionGallery.vue?vue&type=script&lang=js"
import style0 from "./SectionGallery.vue?vue&type=style&index=0&id=5988c1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5988c1ba",
  null
  
)

export default component.exports